require('./mortgageRequestMortgageDenial.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { formatText } = require('core/i18n').i18n;
const { connect } = require('react-redux');
// @ commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKMessage } = require('commonsComponents/OKMessage');
// @ components
const { MortgageRequestManagerInfo } = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestManagerInfo/mortgageRequestManagerInfo');
// @ constants
const { COMMONS } = require('constants/mortgageRequestHolderData');
const mortgageRequestStates = require('constants/mortgageRequestStates');
// @ actions
const getMortgageDenialAction = require('actions/mortgageRequest/mortgageRequestMortgageDenial');

class MortgageRequestMortgageDenial extends React.Component {

    constructor(props) {
        super(props);

        this.handleAcceptAndExit = this.handleAcceptAndExit.bind(this);
    }

    handleAcceptAndExit(event) {
        (event) && event.preventDefault();

        this.props.deleteFilesMortgageDenial();
        this.props.history.push('/myprofile/global');
    }

    render() {
        const { mortgageDenial, mortgageRequestState } = this.props;
        const currentStatus = mortgageRequestState.get('estado');
        const managerTitle = formatText('mortgageRequestManagerInfo-yourManager');
        let prefix;

        switch (currentStatus) {
            case mortgageRequestStates.MODEL_CORRECT:
                prefix = 'mortgageRequestMortgageDenialOthers';
                break;
            case mortgageRequestStates.ERROR_BUREAUS:
                prefix = 'mortgageRequestMortgageDenialASNEF';
                break;
            default:
                prefix = 'mortgageRequestMortgageDenialOthers';
        }

        const contentTitle = formatText(`${prefix}-contentTitle`);
        const contentText1 = formatText(`${prefix}-contentText1`);
        const contentText2 = formatText(`${prefix}-contentText2`, [COMMONS.MORTGAGE_DENIAL_PHONE]);
        const warningMessage = formatText(`${prefix}-warningMessage`);
        const acceptAndExitText = formatText('mortgageRequestCommons-acceptAndExitText');
        let isSaving = mortgageDenial.get('isFetching');

        return (
            <div className="row no-outside-gutter">

                <div className="col-xs-7">

                    <ContentBox>

                        <div className="mortgage-request-mortgage-denial__title">
                            <OKBoxTitle value={contentTitle} />
                        </div>

                        <div className="mortgage-request-mortgage-denial__description">
                            <p>{contentText1}</p>
                            <span>{contentText2}</span>
                        </div>
                        <div className="mortgage-request-mortgage-denial__warning">
                            <OKMessage type="important">
                                {warningMessage}
                            </OKMessage>
                        </div>

                        <div className="mortgage-request-mortgage-denial__footer">
                            <OKButton block={false}
                                onClick={this.handleAcceptAndExit}
                                modifier="primary"
                                loading={isSaving}>
                                {acceptAndExitText}
                            </OKButton>
                        </div>

                    </ContentBox>

                </div>

                <div className="col-xs-5">
                    <ContentBox>
                        <MortgageRequestManagerInfo managerTitle={managerTitle} />
                    </ContentBox>
                </div>

            </div>
        );
    }
}

MortgageRequestMortgageDenial.propTypes = {
    history: PropTypes.object.isRequired,
    mortgageDenial: PropTypes.object,
    mortgageRequestState: PropTypes.object,
    deleteFilesMortgageDenial: PropTypes.func
};

module.exports.constructor = MortgageRequestMortgageDenial;
module.exports.MortgageRequestMortgageDenial = connect(
    state => ({
        mortgageDenial: state.mortgageRequestMortgageDenial,
        mortgageRequestState: state.mortgageRequestState
    }), {
        deleteFilesMortgageDenial: getMortgageDenialAction.deleteFilesMortgageDenial
    }
)(withRouter(MortgageRequestMortgageDenial));
